export interface SecureDocsStatusModel {
    total_files: number
    completed_files: number
    total_recipients: number
    incompleted_files: number
    recent_activity: RecentActivityModel[]
}

export const mapToSecureDocsStatusModel = (x: any): SecureDocsStatusModel => {
    return {
        total_files: x.total_files,
        completed_files: x.completed_files,
        total_recipients: x.total_recipients,
        incompleted_files: x.incompleted_files,
        recent_activity: x.recent_activity ? x.recent_activity.map(mapToRecentActivityModel) : [],
    } as SecureDocsStatusModel;
}

export interface RecentActivityModel {
    action: string
    timestamp: string
    status: number
    message: string
    file_name: string
    user_name: string
}

export const mapToRecentActivityModel = (x: any): RecentActivityModel => {
    return {
        action: x.action,
        timestamp: x.timestamp,
        status: x.status,
        message: x.message,
        file_name: x.file_name,
        user_name: x.user_name,
    } as RecentActivityModel;
}
